<ng-container>
  <ngx-intl-tel-input [cssClass]="'form-control'" [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
    [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
    [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.SaudiArabia" [maxLength]="16"
    [separateDialCode]="false" [(ngModel)]="model" #ng="ngModel" #cont [required]="isRequired" [disabled]="disabled"
    [onlyCountries]="preferredCountries">
  </ngx-intl-tel-input>
  <span *ngIf="(ng.touched || showMessages) && ng.invalid">
    <label *ngIf="ng.errors.validatePhoneNumber" class="text-danger">
      *{{'::VLD_invalid'|abpLocalization :('::FLD_Mobile'|abpLocalization)}}
    </label>
    <label *ngIf="ng.errors.required" class="text-danger">
      *{{'::VLD_required'|abpLocalization }}
    </label>
  </span>
</ng-container>